import classNames from "classnames";
import React from "react";

import css from "./delta_arrow.module.scss";

type DeltaArrowProps = {
  delta: number;
};

const prepareType = (delta: number) => {
  if (delta < 0) {
    return "negative";
  } else if (delta > 0) {
    return "positive";
  }
  return "neutral";
};

const DeltaArrow = ({ delta }: DeltaArrowProps) => {
  const displayValues = {
    positive: {
      className: css.deltaPositive,
      prefix: "↗ +"
    },
    negative: {
      className: css.deltaNegative,
      prefix: "↘ "
    },
    neutral: {
      className: css.deltaNeutral,
      prefix: "→  "
    }
  };

  const type = prepareType(delta);

  return (
    <p className={classNames(css.delta, displayValues[type].className)}>
      {`${displayValues[type].prefix} ${delta.toFixed(2)}%`}
    </p>
  );
};

export default DeltaArrow;
